var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5631 11.5871C34.7822 18.4277 32.2857 26.1059 26.4606 30.2941C20.6355 34.6218 12.7299 34.6218 6.9048 30.2941C1.07967 25.9663 -1.41681 18.4277 0.802286 11.5871C3.02138 4.74654 9.40129 0 16.6133 0C23.9641 0 30.344 4.74654 32.5631 11.5871ZM16.752 1.53564C10.2334 1.53564 4.40831 5.72376 2.32791 12.0059C0.247509 18.2881 2.46661 25.1287 7.87565 29.0376C13.146 32.9465 20.3581 32.9465 25.6284 29.0376C30.8988 25.1287 33.1179 18.2881 31.1762 12.0059C29.0958 5.72376 23.2706 1.53564 16.752 1.53564Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6753 13.9436V23H11.1982V13.9436H13.6753ZM13.8735 11.4466C13.8735 12.2591 13.2195 12.9131 12.4268 12.9131C11.6341 12.9131 11 12.2591 11 11.4466C11 10.654 11.6341 10 12.4268 10C13.2195 10 13.8735 10.654 13.8735 11.4466ZM23.5442 17.4314V23H21.0671V18.3826C21.0671 15.6082 17.7774 15.8262 17.7774 18.3826V23H15.3201V13.9436H17.7774V15.4101C18.9268 13.2698 23.5442 13.1113 23.5442 17.4314Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d9318468f5c9776ebc68ea22909a0a67.svg";
export { ForwardRef as ReactComponent };